import countries from "i18n-iso-countries";

// register all locales you want (add a file e.g. fr, etc)
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

const OMIT_CC_LIST = [
  "aq",
  "bq",
  "cw",
  "gg",
  "im",
  "je",
  "bl",
  "mf",
  "sx",
  "ss",
  "xk"
];

export const addressSrv = {
  countryName(countryCode: string): string {
    return countries.getName(countryCode.toUpperCase(), "en");
  },
  getCountryCodeOptions(): Array<{ name: string; code: string }> {
    return Object.entries(countries.getNames("en"))
      .filter(([code]) => !OMIT_CC_LIST.includes(code.toLowerCase()))
      .map(([code, name]: [code: string, name: string]) => ({
        name,
        code
      }));
  }
};
